// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33AYm","toggleWrap":"styles_toggleWrap__2eUKq","content":"styles_content__3qjwA","selectAreaCode":"styles_selectAreaCode__2dUVZ"};